import { render, staticRenderFns } from "./CreateUpsellSync.vue?vue&type=template&id=1b829b09"
import script from "./CreateUpsellSync.vue?vue&type=script&lang=ts"
export * from "./CreateUpsellSync.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports